import environment from 'platform/utilities/environment';

// Veterans Legacy Memorial. The menu link to its public site (from Drupal)
// goes, for a signed-in user, to an Okta bookmark that carries their session
// into VLM instead. The bookmark is fixed per environment, not per user.
const SIGNED_IN_HREF = environment.isProduction()
  ? 'https://login.va.gov/home/bookmark/0oa1wfi9xdmEa0pOI0j7/2557'
  : 'https://login-stg.va.gov/home/bookmark/0oa1w5ed2wSgp2TtG0j7/2557';

// Only VLM's home page (sqa is its staging site): a deeper VLM link keeps its
// own destination.
const VLM_HOME = /^https:\/\/(www\.|sqa\.)?vlm\.cem\.va\.gov\/?$/i;

/**
 * The menu data with any link to VLM's home page pointed at the signed-in
 * bookmark when the user is signed in; unchanged otherwise.
 *
 * @param {Array} menuData - mega menu data from the page
 * @param {boolean} loggedIn
 * @returns {Array}
 */
export const withVlmLinkForUser = (menuData, loggedIn) =>
  loggedIn
    ? JSON.parse(JSON.stringify(menuData), (key, value) =>
        key === 'href' && VLM_HOME.test(value) ? SIGNED_IN_HREF : value,
      )
    : menuData;
